// extracted by mini-css-extract-plugin
module.exports = {"cardContainer":"card_cardContainer__3RLMQ","title":"card_title__2uEL7","inActive":"card_inActive__2dOBl"};